export const AWARDS_TYPE_ENUM = {
  LIBRARY_AWARD_TEMPLATE: {
    Id: -6,
    Code: 'LIBRARY_AWARD_TEMPLATE',
    Label: 'Library Rates',
  },
  HOURLY: { Id: -1, Code: 'HOURLY', Label: 'Hourly' },
  RATES_PER_DAY: {
    Id: 'global/7Days.json',
    Code: 'RATES_PER_DAY',
    Label: 'Rates Per Day',
    ServiceHook: 'ratesperday',
  },
  HOURLY_FLAT_40_AND_TIMEHALF_OVERTIME: {
    Id: -2,
    Label: 'Hourly (1.5 x Overtime)',
    ContractPrefix: 'DP_OVT1',
    Code: 'HOURLY_FLAT_40_AND_TIMEHALF_OVERTIME',
  },
  HOURLY_44: {
    Id: 'global/casual-2021-09-07-hourly-1',
    Label: 'Hourly (44 h + 1.5 x Overtime)',
    Code: 'HOURLY_44',
    Pattern: /global\/casual-2021-09-07-hourly-\d+/g,
  },
  FIXED_RATE: {
    Id: 'global/fulltime-2022-03-15-hourly-fixedrate-1',
    Label: 'Fixed Rate',
    Code: 'FIXED_RATE',
    Pattern: /global\/fulltime-2022-03-15-hourly-fixedrate-\d+/g,
  },
  SALARY: { Id: -3, Code: 'SALARY', Label: 'Salary', ContractPrefix: 'DP_SAL' },
  SALARY_CONTRACT: {
    Id: 'SALARY_CONTRACT',
    Code: 'SALARY_CONTRACT',
  },
  ABP_TYPE_ENUM: {
    Id: -7,
    Code: 'AREA_BASED_PAY',
    PREFIX: 'DP_ABP',
    HOURLY: 'ABP_Hourly',
    HOURLY_FLAT_40_AND_TIMEHALF_OVERTIME: 'ABP_HourlyAndTimehalf',
    HOURLY_44: 'ABP_Hourly44AndTimehalf',
    FIXED_RATE: 'ABP_FixedRate',
    RATE_PER_DAY: 'ABP_RatesPerDay',
    LIBRARY: 'Area Rate',
    CUSTOM: 'ABP_Custom',
  },
  CUSTOM_TERM: { Id: -5, Code: 'CUSTOM_TERM', Label: 'Custom Rates' },
  EXTERNAL: { Id: -4, Code: 'EXTERNAL', Label: 'External Rates' },
  OTHER: { Id: -8, Code: 'OTHER', Label: 'Other' },

  // this is for the view mode only when the employee doesn't have pay details
  DEFAULT: { Id: null, Code: 'DEFAULT', Label: 'No pay rate' },
} as const;

export const SALARY_DISTRIBUTION_ENUM = {
  TYPE: {
    NO_DISTRIBUTION: { Id: -1, Label: 'No Allocation' },
    DAYS_OF_WEEK: { Id: 0, Label: 'Days of the Week - fixed days' },
    SCHEDULED_HOURS: { Id: 1, Label: 'Scheduled Hours' },
    SCHEDULED_DAYS: { Id: 3, Label: 'Scheduled Days' },
  },
  PERIOD: {
    ANNUAL: { Id: 0, Label: 'Annual', Key: 'AnnualSalary' },
    WEEKLY: { Id: 1, Label: 'Weekly', Key: 'WeeklySalary' },
  },
  DAY_OF_WEEK: {
    DAY_TO_INT: { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 },
    INT_TO_DAY: {
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat',
      7: 'Sun',
    },
  },
  CUSTOM_APP_DATA_CONFIG: {
    DOCUMENT_ID_PREFIX: 'SALARY_DIST_CONFIG',
    KEY_TYPE: 'distribution_type',
    KEY_DAYS_OF_WEEK: 'days_of_week',
    KEY_ASSOC_AREAS_FOR_SCHEDULED: 'assoc_areas_for_scheduled',
    KEY_INCLUDE_LEAVE_PH_IN_SCHEDULED_HOURS:
      'include_leave_ph_in_scheduled_hours',
    KEY_AGREEMENT_ID_FOR_AREAS_ASSOC: 'agreement_id_for_areas_assoc',
    KEY_WEEKLY_SALARY: 'weekly_salary',
  },
  ALLOCATION_OPTIONS: {
    OPTION_SCHEDULED_AREAS: 1,
    OPTION_SPECIFIC_AREAS: 2,
  },
};

export const DEFAULT_AWARD_TYPE = AWARDS_TYPE_ENUM.HOURLY.Id;

export const ABP_IDENTIFIER = 'DP_ABP';

export const employmentTypes = [
  { value: 1, label: 'Full time' },
  { value: 2, label: 'Part time' },
  { value: 3, label: 'Casual' },
  { value: 4, label: 'Contractor' },
  { value: 5, label: 'Hourly' },
  { value: 6, label: 'Salary' },
];

export const EMPLOYMENT_TYPE = {
  FULL_TIME: 1,
  PART_TIME: 2,
  CASUAL: 3,
  CONTRACTOR: 4,
  HOURLY: 5,
  SALARY: 6,
};

export const PAY_RULE_ENUM = {
  REMUNERATION_TYPE: {
    HOURLY: { Id: 1, Label: 'Hourly' },
    SALARY: { Id: 2, Label: 'Salary' },
    UNIT: { Id: 3, Label: 'Unit' },
  },
  REMUNERATION_BY: {
    BASE: { Id: 1, Label: 'Base' },
    SHIFT_LOADING: { Id: 2, Label: 'Shift Loading' },
    PERIOD_LOADING: { Id: 3, Label: 'Period Loading' },
  },
  MULTIPLIER_BASE_RATE: {
    SHIFT_BASE_RATE: { Id: -1, Label: 'Shift Base Rate' },
    EMP_BASE_RATE: { Id: -2, Label: 'Base Rate' },
  },
};

export const AWARDS_TYPES = [
  'LIBRARY_AWARD_TEMPLATE',
  'HOURLY',
  'RATES_PER_DAY',
  'HOURLY_FLAT_40_AND_TIMEHALF_OVERTIME',
  'HOURLY_44',
  'FIXED RATE',
  'SALARY',
  'CUSTOM_TERM',
  'EXTERNAL',
];

export const keysHourlyPayRate = {
  weekday: 'WkdRate',
  saturday: 'SatRate',
  sunday: 'SunRate',
  publicHoliday: 'PHolRate',
};

export const keysHourlyPayRateForBulkAction = {
  weekday: 'fltWkdRate',
  saturday: 'fltSatRate',
  sunday: 'fltSunRate',
  publicHoliday: 'fltPHolRate',
};

export const PAY_PERIOD_CYCLES = {
  WEEKLY: 1,
  FORTNIGHTLY: 2,
  MONTHLY: 3,
  EVERY_3_WEEKS: 4,
  EVERY_4_WEEKS: 5,
  BIMONTHLY: 6,
};
